import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el pack después de comprar?',
  a: 'Inmediatamente después del pago recibís un email con el link de descarga. Acceso al instante, sin esperas.'
}, {
  q: '¿En qué formato vienen los tomos?',
  a: 'Son archivos PDF de alta calidad, optimizados para ver en celular, tablet y computadora. No necesitás ningún programa especial.'
}, {
  q: '¿Los ingredientes son difíciles de conseguir?',
  a: 'No. Todas las recetas están diseñadas con ingredientes que conseguís en cualquier verdulería, almacén o supermercado de Argentina.'
}, {
  q: '¿Necesito experiencia cocinando?',
  a: 'Para nada. Cada receta tiene pasos claros y simples. Si podés hervir agua, podés hacer estas recetas.'
}, {
  q: '¿Sirve si no soy 100% vegana/vegetariana?',
  a: 'Sí. El pack es perfecto para cualquier persona que quiera incorporar más comida vegetal, aunque siga comiendo carne ocasionalmente.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés 7 días de garantía total. Si no te convence, te devolvemos el 100% del dinero sin preguntas.'
}, {
  q: '¿Puedo comprarlo desde otro país?',
  a: 'Sí. Desde otros países de Latinoamérica podés comprar a través de Hotmart con tu tarjeta o billetera digital.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-[#0a0a0a] py-24 px-4" data-id="element-49">
      <div className="max-w-3xl mx-auto" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-52">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-53">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-zinc-800 rounded-xl overflow-hidden bg-[#18181b]" data-id="element-54">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-55">
                <span className="font-bold text-white pr-4" data-id="element-56">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-emerald-500 transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-57" />
              </button>
              <AnimatePresence data-id="element-58">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-59">
                    <div className="px-6 pb-5 text-zinc-400 leading-relaxed" data-id="element-60">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}